import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './../styles/Header.css'
import logo from '../assets/logos/qatech-logo.svg'

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest('nav') && isOpen) {
        setIsOpen(false)
      }
    }

    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      setScrolled(isScrolled)
    }

    document.addEventListener('click', handleOutsideClick)
    window.addEventListener('scroll', handleScroll)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isOpen])

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo-container">
        <Link to="/" className="logo-link">
          <img src={logo} alt="QA Tech Logo" className="logo" />
          <div className="company-info">
            <span className="company-name">QA Tech</span>
            <span className="company-tagline">Building Confidence Through Quality</span>
          </div>
        </Link>
      </div>
      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <ul className="nav-links" onClick={closeMenu}>
          {/* <li>
            <Link to="/" className="nav-link">
              <span>Home</span>
            </Link>
          </li> */}
          {/* <li>
            <Link to="/services" className="nav-link">
              <span>Services</span>
            </Link>
          </li> */}
          {/* <li>
            <Link to="/about" className="nav-link">
              <span>About</span>
            </Link>
          </li> */}
          {/* <li>
            <Link to="/community" className="nav-link">
              <span>Community</span>
            </Link>
          </li> */}
          <li>
            <Link to="/case-studies" className="nav-link">
              <span>Case Studies</span>
            </Link>
          </li>
          <li>
            <Link to="/marketing" className="nav-link">
              <span>Marketing</span>
            </Link>
          </li>
          <li>
            <Link to="/contact" className="nav-link cta-link">
              <span>Contact</span>
            </Link>
          </li>
        </ul>
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </nav>
    </header>
  )
}

export default Header
